var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasicUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.036,
    height: 104.191,
    viewBox: "0 0 68.036 104.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3f18aa;\n        font-size: 34px;\n        font-family: Roboto-Bold, Roboto;\n        font-weight: 700;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basic_user",
    transform: "translate(-112 -666.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_person_24px",
    d: "M37.508,37.508A16.754,16.754,0,1,0,20.754,20.754,16.749,16.749,0,0,0,37.508,37.508Zm0,8.377C26.325,45.885,4,51.5,4,62.639v8.377H71.016V62.639C71.016,51.5,48.692,45.885,37.508,45.885Z",
    transform: "translate(109.02 662.383)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Free",
    className: "cls-1",
    transform: "translate(112 761.574)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Free")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicUser);
export default __webpack_public_path__ + "static/media/basic_user.d253fe344fecccf3abb6d5a6c52abdcd.svg";
export { ForwardRef as ReactComponent };